export default "__VITE_ASSET__BXXMjtx8__"